import React, { KeyboardEvent, useEffect, useMemo, useState, useRef, memo } from "react";
import {
  Button,
  Form,
  Icon,
  Label,
  Input,
  Popup,
  Modal,
  FormGroup,
  Tab,
  Table,
  TabProps,
  Menu,
} from "semantic-ui-react";
import SwipeableViews from "react-swipeable-views";

// ux
import CardOPDLabSummary from "react-lib/apps/HISV3/LAB/CardOPDLabSummary";
import CardSharedLabResult from "react-lib/apps/MEH/CardSharedLabResult";

// Interface
import { State as OPDLabSummarySequence } from "react-lib/apps/HISV3/LAB/sequence/OPDLabSummary";
import { State as LabReportSequence } from "react-lib/apps/HISV3/LAB/sequence/LabReport";
import { State as SharedLabResultSequence } from "react-lib/apps/MEH/sequence/SharedLabResult";

// Serializer
import CentralLabOrderSimplifiedSerializer from "issara-sdk/types/CentralLabOrderSimplifiedSerializer_apps_LAB";

// scss
import "./CardMeLabResult.scss";

const CARD_KEY = "CardMeLabResult";

type CardMeLabResultProps = {
  setProp: any;
  onEvent: any;
  runSequence: any;
  OPDLabSummarySequence?: OPDLabSummarySequence["OPDLabSummarySequence"];
  LabReportSequence?: LabReportSequence;
  // shared lab result
  SharedLabResultSequence?: SharedLabResultSequence["SharedLabResultSequence"];
  // data
  django?: Record<string, any>;
  selectedPatient?: Record<string, any>;
  centralLabResultList?: {
    items?: Record<string, any>[];
  };
  errorMessage?: Record<string, any>;
  buttonLoadCheck?: Record<string, any>;
  permissionLabResultConfidential?: boolean;
  patientInfo?: Record<string, any>;
  searchedItemListWithKey?: Record<string, any>;
  selectedLabOrderWorking?: CentralLabOrderSimplifiedSerializer;
  languageUX?: string;
  // options
  masterOptions?: Record<string, any>;
  // config
  type?: "CUMULATIVE_LAB_RESULT";
};

const COLOR = {
  primary: "var(--primary-theme-color)",
};

const CardMeLabResult = (props: CardMeLabResultProps) => {
  const [viewIndex, setViewIndex] = useState<any>(0);

  const swipeableRef = React.useRef<any>();

  const panes = React.useMemo(
    () => [
      {
        menuItem: (
          <Menu.Item className={viewIndex === 0 ? "tabActive" : "tabs"}>Lab Summary</Menu.Item>
        ),
      },
      {
        menuItem: (
          <Menu.Item className={viewIndex === 1 ? "tabActive" : "tabs"}>
            Cumulative Lab Result
          </Menu.Item>
        ),
      },
      {
        menuItem: (
          <Menu.Item className={viewIndex === 2 ? "tabActive" : "tabs"}>
            Shared Lab Result
          </Menu.Item>
        ),
      },
    ],
    [viewIndex],
  );

  return (
    <div className="CardMeLabResult" style={{ marginTop: "20px" }}>
      <Tab
        menu={{ secondary: true, pointing: true }}
        panes={panes}
        activeIndex={viewIndex}
        onTabChange={(event: any, data: TabProps) => {
          setViewIndex(data.activeIndex);
        }}
      />
      <SwipeableViews
        ref={swipeableRef}
        animateTransitions={false}
        index={viewIndex}
        onChangeIndex={(index: number) => {
          setViewIndex(index);
        }}
        style={{
          marginTop: "20px",
          height: "100%",
        }}
      >
        <div>
          <CardOPDLabSummary
            setProp={props.setProp}
            onEvent={props.onEvent}
            // seq
            runSequence={props.runSequence}
            OPDLabSummarySequence={props.OPDLabSummarySequence}
            LabReportSequence={props.LabReportSequence}
            // data
            django={props.django}
            // CommonInterface
            permissionLabResultConfidential={props.permissionLabResultConfidential}
            selectedPatient={props.selectedPatient}
            centralLabResultList={props.centralLabResultList}
            errorMessage={props.errorMessage}
            buttonLoadCheck={props.buttonLoadCheck}
            patientInfo={props.selectedPatient}
            searchedItemListWithKey={props.searchedItemListWithKey}
            // options
            masterOptions={props.masterOptions}
            languageUX={props.languageUX}
            // config
            hideTitle={true}
            isMeLab={true}
          />
        </div>
        <div>
          <CardOPDLabSummary
            setProp={props.setProp}
            onEvent={props.onEvent}
            // seq
            runSequence={props.runSequence}
            OPDLabSummarySequence={props.OPDLabSummarySequence}
            LabReportSequence={props.LabReportSequence}
            // data
            django={props.django}
            // CommonInterface
            selectedPatient={props.selectedPatient}
            centralLabResultList={props.centralLabResultList}
            errorMessage={props.errorMessage}
            buttonLoadCheck={props.buttonLoadCheck}
            permissionLabResultConfidential={props.permissionLabResultConfidential}
            patientInfo={props.selectedPatient}
            searchedItemListWithKey={props.searchedItemListWithKey}
            // options
            masterOptions={props.masterOptions}
            // config
            hideTitle={true}
            isMeLab={true}
            type={"CUMULATIVE_LAB_RESULT"}
            languageUX={props.languageUX}
          />
        </div>
        <div>
          <CardSharedLabResult
            setProp={props.setProp}
            onEvent={props.onEvent}
            // seq
            runSequence={props.runSequence}
            // options
            masterOptions={props.masterOptions}
            buttonLoadCheck={props.buttonLoadCheck}
            SharedLabResultSequence={props.SharedLabResultSequence}
            viewIndex={viewIndex}
            languageUX={props.languageUX}
          />
        </div>
      </SwipeableViews>
    </div>
  );
};

CardMeLabResult.displayName = "CardMeLabResult";

export default memo(CardMeLabResult);
